// Protecting Global Scope
var _Portal = _Portal || {};
(function () {
    //_Portal.changeCompany = function (event) {
    //    var menuHdr = $('#companySelect');
    //    var ele = event.currentTarget;
    //    $.ajax({
    //        type: 'POST', url: '/Account/User/ChangeCompany', data: 'cid=' + ele.getAttribute('value'), success: function (response) {
    //            if (response) {
    //                if (window.location.pathname.indexOf('ProjectReview') > -1) {
    //                    // Clear search so it will redirect user back to MainInfo page
    //                    window.location.search = null;
    //                } else {
    //                    // Reload page so company update takes affect
    //                    window.location.reload();
    //                }
    //            }
    //        }
    //    });
    //    var opts = $('.companySelection');
    //    opts.removeClass('k-state-selected');
    //    ele.classList.add('k-state-selected');
    //    menuHdr.text = ele.textContent;
    //};
  var sendAfToken;
    //Kendo Events
    //Project Review Page
    kendo._l = kendo._l || {};
    /*kendo._l.onJobChange = function () {
        var $kendoButton = $('#btnLoadProject').data('kendoButton'),
            $jobSearch   = $('#projectTitle').data('kendoAutoComplete'),
            searchValue  = $jobSearch.value(),
            isValidJob   = searchValue != null && !isNaN(parseInt(searchValue.substr(0, 8))) && searchValue.length >= 8;

        $kendoButton.enable(isValidJob);
    };*/

    /*kendo._l.onJobSelect = function () {
        $('#btnLoadProject').data('kendoButton').enable(true);
    };*/

    //Approval Section
    /*kendo._l.onEmpChange = function () {
        var empNum = this.value(), isValidEmp = empNum.split('-').length > 1 && !isNaN(parseInt(empNum.split('-')[0])), role = this.element[0].id.split('_')[1];

        $('#mprExecSumApprovalBtn_' + role).data('kendoButton').enable(isValidEmp);
    };

    kendo._l.onEmpSelect = function () {
        var role = this.element[0].id.split('_')[1];
        $('#mprExecSumApprovalBtn_' + role).data('kendoButton').enable(true);
    };*/

    //Kendo Windows
    /*kendo._l.onOpenWindow = function () {
        // Prevent background scrolling
        $('html, body').css('overflow', 'hidden');
        this.element.parent().css('top', '').css('left', '').addClass('centerWindow');
        if (this.element.attr('id') === 'calculationWindow') {
            //this.element.parent().css('width', '50%').css('height', '');
            this.element.parent().addClass('calculationWindow');
        }
    };*/
    kendo._l.showKendoWindow = function (id) {
        event.preventDefault(); // stop postback/submit
        $('#' + id).data('kendoWindow').open();
        return false;
    };
    kendo._l.recenterNearestKendoWindow = function (id) {
        var baseElement = $('#' + id);
        var kWin = baseElement.closest('.k-window-content').data('kendoWindow');
        kWin.element.parent().css('top', '').css('left', '').addClass('centerWindow');
        return false;
    };

    // kendo Notification
    var showNotification = function (type, msg) {
        if (type != null) {
            $('#notification').data('kendoNotification').show({
                icon: type, message: msg || type, autoHideAfter: 15000
            }, type);
        }
    };
    kendo._l.showSuccessNotification = function (msg) {
        showNotification('success', msg || 'Form Saved!');
    };
    kendo._l.showErrorNotification = function (msg) {
        showNotification('error', msg || 'Error Saving Form!');
    };
    kendo._l.showInfoNotification = function (msg) {
        showNotification('info', msg || 'Info');
    };
    kendo._l.showWarningNotification = function (msg) {
        showNotification('warning', msg || 'Watch Out!');
    };
    kendo._l.onCloseWindow = function () {
        //restore default scrolling
        $('html, body').css('overflow', '');
    };
    kendo._l.closeThisWindow = function (self) {
        $('#' + self).data('kendoWindow').close();
    };

    //Document Ready events
    // AutoComplete
    _Portal.preventGoogleAutoComplete = function () {
        $('[data-role=autocomplete]').attr('autocomplete', 'off');
    };

    //Page Ready
    $(document).ready(function () {
        _Portal.preventGoogleAutoComplete();
    });

    /*Primitive Functions*/
    /*Number.prototype.DivideBy = function (denom) {
        if (denom !== 0) return this / denom; else return 0;
    };
    Number.prototype.GetPercentage = function (denom, decimals) {
        var formatString = '##';
        if (decimals === null || decimals === undefined || decimals < 0) {
            decimals = 1;
        }
        if (decimals > 0) {
            formatString += '.';
        }
        while (decimals > 0) {
            formatString += '0';
            decimals--;
        }

        return kendo.toString(100 * this.DivideBy(denom), formatString) + '%';
    };
    String.prototype.RemoveCharacters = function (char) {
        // if (typeof (this) !== typeof ('')) {
        //     console.error("Object is not a string.")
        //     return;
        // }
        return this.split(char).join('');
    };*/
})();